
/* ============================== src/components/Templates/useNestedModalEscape.js ============================== */
import { useEffect, useLayoutEffect, useRef } from "react";

/**
 * Стек активных перехватчиков Escape.
 *
 * Раньше обработчик просто глушил клавишу через stopImmediatePropagation.
 * Этого достаточно для одного уровня (модалка + ConfirmDialog, где
 * ConfirmDialog ловит событие в фазе погружения, а модалка - во всплытии),
 * но при двух и более «перехватчиках» зарегистрированные раньше гасили
 * событие раньше остальных: Escape закрывал внешнюю модалку вместо
 * внутренней.
 *
 * Теперь каждый экземпляр кладёт в стек уникальный токен и реагирует на
 * клавишу только если он - верхний. Порядок стека = порядок монтирования,
 * то есть «сверху вниз» по визуальному слою. Escape закрывает ровно один
 * слой - верхний.
 *
 * Колбэк onEscape читается через ref: ссылка на функцию меняется каждый
 * рендер родителя (обычно это inline-стрелка), и держать её в deps
 * useEffect значило бы пересоздавать слушатель на каждом рендере -
 * с микро-окном между cleanup и setup, в котором keydown не обработан
 * никем. Ref + useLayoutEffect (обновляет ref до paint) убирают и
 * окно, и лишнюю работу.
 */
const escapeStack = [];

export function useNestedModalEscape(onEscape) {
  const onEscapeRef = useRef(onEscape);
  useLayoutEffect(() => {
    onEscapeRef.current = onEscape;
  }, [onEscape]);

  useEffect(() => {
    const token = {};
    escapeStack.push(token);

    const handler = (event) => {
      if (event.key !== "Escape") return;
      if (escapeStack[escapeStack.length - 1] !== token) return;
      event.stopImmediatePropagation();
      onEscapeRef.current();
    };

    window.addEventListener("keydown", handler, true);

    return () => {
      window.removeEventListener("keydown", handler, true);
      const idx = escapeStack.indexOf(token);
      if (idx !== -1) escapeStack.splice(idx, 1);
    };
  }, []);
}
